import {createLazyComponent} from 'helpers/createLazyComponent'
import mapParams from 'helpers/hocs/mapParams'
import React from 'react'

const FamilyBookDetailLazy = createLazyComponent(() => import('./containers/FamilyBookDetail'))

const FamilyBookDetail = (props) => <FamilyBookDetailLazy {...props} />

export default mapParams()(FamilyBookDetail)
